import React, { useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import {
  Container,
  Row,
  Button,
  Col,
  Form,
  Card,
  CardGroup,
  Table,
} from "react-bootstrap";
import Print from "../components/Print"
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const PrintScreen = () => {
    const navigate = useNavigate();

    const componentRef = useRef();

    //user selector
    const { userInfo } = useSelector((state) => state.user);

    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    useEffect(() => {
        if (!userInfo) {
            toast.error("Please Login To Get Access!!", { position: "top-center" });
            navigate("/login");
        }
    }, [userInfo, navigate]);

  return (
    <Container fluid>
      <Row className="my-3">
        <h5 className="d-flex flex-row justify-content-center">
          Print Preview
        </h5>
      </Row>

      {/* Table */}
      <Card className="shadow">
        <Card.Header className="text-center text-black p-3" as="h5">
          Employees List
        </Card.Header>
        <Table rounded bordered hover responsive style={{ maxHeight: "80vh" }}>
          <thead className="text-center">
            <tr>
              {/* <th>Agent Name</th>
                    <th>Phone No.</th>
                    <th>Salary</th>
                    <th>Commission</th>

                    <th>Loan</th>
                    <th>Monthly Deduction</th>

                    <th>Payable Amount</th>

                    <th>Edit</th>
                    <th>Delete</th>
                    <th>Print</th> */}
            </tr>
          </thead>
        </Table>
      </Card>
      {/* <hr />
      <Row className="mb-3">
        <Print ref={componentRef} />
      </Row>
      <hr /> */}
      <Row>
        <button className="btn btn-primary mb-3" onClick={handlePrint}>
          Print Reciept
        </button>
      </Row>
    </Container>
  );
};

export default PrintScreen;
